import { api } from '@/lib/api';
import { toast } from 'sonner';

/**
 * Download an XLSX from a backend endpoint using axios+blob.
 * @param {string} path  - API path (e.g. '/admin/exports/sellers')
 * @param {string} filename - Suggested filename for download
 * @param {object} params - Query params
 */
export async function downloadXlsx(path, filename, params = {}) {
  try {
    const { data } = await api.get(path, {
      params,
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 500);
    toast.success(`Descarga iniciada: ${filename}`);
  } catch (e) {
    toast.error('Error al descargar el archivo');
  }
}

/** Download a CSV from a backend endpoint using axios+blob. */
export async function downloadCsv(path, filename, params = {}) {
  return downloadXlsx(path, filename, params);
}
